import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4" }
const _hoisted_2 = { class: "flex justify-center md:justify-start flex-wrap flex-row md:mr-auto md:ml-0 mx-auto w-full" }
const _hoisted_3 = { class: "px-5 md:ml-auto ml-0 flex gap-4 justify-items-center w-full md:w-auto" }
const _hoisted_4 = { class: "px-8 py-6" }
const _hoisted_5 = { class: "space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center" }
const _hoisted_6 = {
  key: 0,
  class: "overflow-auto"
}

import { AxiosInstance } from 'axios'
import { translate } from '@/utils/tools'
import { inject, onMounted, ref } from 'vue'
import Navbar from '@/components/tools/Navbar.vue'
import DataTable from '@/components/tools/DataTable.vue'
import Pagination from '@/components/tools/Pagination.vue'
import { useStore } from 'vuex'
import CreateStreamerBaseDialog from '@/components/dialogs/CreateStreamerBaseDialog.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'streamer',
  setup(__props) {

const store = useStore()
const axios = inject('$axios') as AxiosInstance
const pageConfig = ref({
    page: 1,
    rowsPerPage: 10,
    dataLength: 0,
    search: '',
    filters: {},
})
const toastConfig = ref({
    show: false,
    message: '',
    success: true,
    manual_close: false,
})
const pageData = ref([])
const columns = ref([
    // {
    //     label: translate('messages.stream.streamer.id'),
    //     field: 'id',
    // },
    // {
    //     label: translate('messages.stream.streamer.operatorId'),
    //     field: 'operatorId',
    // },
    {
        label: translate('messages.stream.streamer.name'),
        field: 'name',
    },
    {
        label: translate('messages.stream.streamer.imageUrl'),
        field: 'imageUrl',
    },
    {
        label: translate('messages.stream.streamer.description'),
        field: 'description',
    },
    {
        label: translate('messages.stream.streamer.isActive'),
        field: 'isActive',
        isToggle: true,
        function: async (data: any) => {
            data.isActive =  !data.isActive
            await axios
                .put<any>(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/stream/api/internal/streamer`, data)
                .then((response) => response.data)
        },
    },
    // {
    //     label: translate('messages.stream.streamer.createdAt'),
    //     field: 'createdAt',
    //     format: (data: any) => dayjs(data.createdAt).format("YYYY-MM-DD HH:mm:ss"),
    // },
    // {
    //     label: translate('messages.stream.streamer.updatedAt'),
    //     field: 'updateAt',
    //     format: (data: any) => dayjs(data.createdAt).format("YYYY-MM-DD HH:mm:ss"),
    // }
])

const isLoaded = ref<boolean>(false)
const formLoading = ref<boolean>(false)
const showCreateStreamerModal = ref<boolean>(false)
const showAdvanceFilterModal = ref<boolean>(false)
const showStreamerDetailDialog = () => console.log('show detail')
const getPageData = async () => {
    const { search, page, rowsPerPage, filters } = pageConfig.value
    isLoaded.value = false
    await axios
        .post<any>(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/stream/api/internal/streamers/list`, {
            page,
            search,
            filters,
            operatorId: store.state.selectedOperator.operatorId,
            pageSize: rowsPerPage,
        })
        .then((response) => pageData.value = response.data.data)
    pageConfig.value.dataLength = pageData.value.length
    showAdvanceFilterModal.value = false
    isLoaded.value = true
}

onMounted(() => {
    getPageData()
})

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.stream.streamer.topic')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "h-8 my-auto bg-blue-500 text-white px-2 rounded-lg hover:ring-2",
            onClick: _cache[0] || (_cache[0] = () => (showCreateStreamerModal.value = true))
          }, _toDisplayString(_ctx.$t('messages.stream.streamer.create')), 1)
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_font_awesome_icon, {
          class: "text-gray-500",
          icon: ['fas', 'circle-notch'],
          transform: "grow-6",
          spin: ""
        })
      ])
    ], 512), [
      [_vShow, !isLoaded.value]
    ]),
    (isLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: pageData.value,
            onShowDetailTable: showStreamerDetailDialog
          }, null, 8, ["columns", "data"]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[1] || (_cache[1] = ($event: any) => ((pageConfig).value = $event)),
            class: "overflow-auto"
          }, null, 8, ["config"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(CreateStreamerBaseDialog, {
      loading: formLoading.value,
      "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((formLoading).value = $event)),
      show: showCreateStreamerModal.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((showCreateStreamerModal).value = $event)),
      onSubmit: _cache[4] || (_cache[4] = () => {
        getPageData();
        showCreateStreamerModal.value = false;
    }
        ),
      onCancel: _cache[5] || (_cache[5] = () => {
            showCreateStreamerModal.value = false;
        }
            )
    }, null, 8, ["loading", "show"])
  ], 64))
}
}

})